import { useEffect } from "react";
import "./ProjectShowcase.css";
import Projects from "../contexts_config/Projects";

export default function ProjectShowcase({
  projectId = "marius-branding",
  onClose,
}) {
  const project = Projects.find((p) => p.id === projectId);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  if (!project) {
    return <div>Project not found</div>;
  }

  return (
    <div className="project_showcase_container" onClick={handleBackdropClick}>
      <div className="project_showcase_content">
        <div className="exit_button" onClick={handleClose}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.5 14.5L14.5 1.5"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5 14.5L1.5 1.5"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="project_showcase_content_left">
          <div className="top_project_showcase_left">
            <div className="cont_project_showimg">
              <img src={project.projectImages[0]} alt="" />
            </div>
          </div>
          <div className="bottom_project_showcase_left">
            {project.teamMembers.map((member, index) => (
              <div className="person_box" key={index}>
                <div className="texte">
                  <h1>{member.name}</h1>
                  <p>{member.role}</p>
                </div>
                <div className="photo_cont">
                  <img src={member.photo} alt="" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="project_showcase_content_right">
          <img src={project.headerImage} alt="" className="img_project_show" />
          <div className="title_project_showcase">
            <h1>
              {project.title} | <span>{project.subtitle}</span>
            </h1>
            <p>{project.description}</p>
          </div>

          <div className="project_showcase_type">
            {project.types.map((type, index) => (
              <div className="type_box" key={index}>
                {type}
              </div>
            ))}
          </div>

          <div className="tools_project_showcase">
            <h1>TOOLS USED</h1>
            <p>{project.tools}</p>
          </div>

          <div className="hive_socials_project">
            {project.socials.map((social, index) => (
              <img key={index} src={social} alt="" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
